import { DEV, TEST } from '../vars';
import type { ConfigName } from './names';

export type ConfigHostsEntry = {
    hideInListing: boolean;
    hosts: string[];
    idFirma: number;
    isDev: boolean;
    /** @deprecated */
    useOldVersion?: true;
};

export const mapHosts: Record<ConfigName, ConfigHostsEntry> = {
    'Local HPT Server': { hosts: ['localhost'], idFirma: 9800, isDev: true, hideInListing: true, useOldVersion: !(DEV || TEST) || undefined },
    'BDK BETA': {
        hosts: [
            'bdk-dev.autohaus-digital.de',
            'bdk-live.autohaus-digital.de',
            'bdk-next.autohaus-digital.de',
            'bdk-pre-release.autohaus-digital.de',
            'bdk-test.autohaus-digital.de',
            'bdk-beta.autohaus-digital.de',
        ],
        idFirma: 54612,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'ACC': {
        hosts: ['acc-dev.autohaus-digital.de', 'acc-live.autohaus-digital.de', 'acc-next.autohaus-digital.de', 'acc-pre-release.autohaus-digital.de', 'acc-test.autohaus-digital.de', 'autocarl.de'],
        idFirma: 30159,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Albertsmeyer': {
        hosts: [
            'albertsmeyer-dev.autohaus-digital.de',
            'albertsmeyer-live.autohaus-digital.de',
            'albertsmeyer-pre-release.autohaus-digital.de',
            'albertsmeyer-test.autohaus-digital.de',
            'albertsmeyer-next.autohaus-digital.de',
        ],
        idFirma: 52400,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'AMB': { hosts: ['amb-autowelt.de'], idFirma: 12290, isDev: false, hideInListing: false, useOldVersion: true },
    'ASS Senftenberg': {
        hosts: [
            'ass-dev.autohaus-digital.de',
            'ass-live.autohaus-digital.de',
            'ass-pre-release.autohaus-digital.de',
            'ass-test.autohaus-digital.de',
            'ass-next.autohaus-digital.de',
            'ass-senftenberg.de',
        ],
        idFirma: 36189,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Auto Diehl': {
        hosts: ['diehl-dev.autohaus-digital.de', 'diehl-live.autohaus-digital.de', 'diehl-pre-release.autohaus-digital.de', 'diehl-test.autohaus-digital.de', 'diehl-next.autohaus-digital.de'],
        idFirma: 30165,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Auto Henke': {
        hosts: [
            'henke-dev.autohaus-digital.de',
            'henke-live.autohaus-digital.de',
            'henke-next.autohaus-digital.de',
            'henke-pre-release.autohaus-digital.de',
            'henke-test.autohaus-digital.de',
            'auto-henke.de',
        ],
        idFirma: 54790,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Autohaus-Digital HPT': {
        hosts: ['fleet-dev.autohaus-digital.de', 'fleet-next.autohaus-digital.de', 'fleet-pre-release.autohaus-digital.de', 'fleet-test.autohaus-digital.de', 'fleet.autohaus-digital.de'],
        idFirma: 9800,
        isDev: true,
        hideInListing: true,
        useOldVersion: !(DEV || TEST) || undefined,
    },
    'Autohaus-Digital S-R': {
        hosts: [
            'web-dev.autohaus-digital.de',
            'web-next.autohaus-digital.de',
            'web-pre-release.autohaus-digital.de',
            'web-test.autohaus-digital.de',
            'web.autohaus-digital.de',
            'ahd-dev.autohaus-digital.de',
            'ahd-next.autohaus-digital.de',
            'ahd-pre-release.autohaus-digital.de',
            'ahd-test.autohaus-digital.de',
            'ahd.autohaus-digital.de',
            'ahddemo-dev.autohaus-digital.de',
            'ahddemo-next.autohaus-digital.de',
            'ahddemo-pre-release.autohaus-digital.de',
            'ahddemo-test.autohaus-digital.de',
            'ahddemo.autohaus-digital.de',
        ],
        idFirma: 9800,
        isDev: true,
        hideInListing: true,
        useOldVersion: !(DEV || TEST) || undefined,
    },
    'Audi Zentrum Zwickau': {
        hosts: [
            'az-zwickau.de',
            'zwickau-dev.autohaus-digital.de',
            'zwickau-live.autohaus-digital.de',
            'zwickau-next.autohaus-digital.de',
            'zwickau-pre-release.autohaus-digital.de',
            'zwickau-test.autohaus-digital.de',
        ],
        idFirma: 10930,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Autoagentur Wolf': {
        hosts: [
            'wolf-dev.autohaus-digital.de',
            'wolf-live.autohaus-digital.de',
            'wolf-next.autohaus-digital.de',
            'wolf-pre-release.autohaus-digital.de',
            'wolf-test.autohaus-digital.de',
            'autoagentur-wolf.de',
        ],
        idFirma: 53860,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Autocenter Burgenland': {
        hosts: [
            'ac-burgenland-dev.autohaus-digital.de',
            'burgenland.autohaus-digital.de',
            'ac-burgenland-next.autohaus-digital.de',
            'ac-burgenland-pre-release.autohaus-digital.de',
            'ac-burgenland-test.autohaus-digital.de',
        ],
        idFirma: 52960,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Autohaus Baumann': { hosts: ['autohaus-baumann.de'], idFirma: 54320, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Baumhoff': { hosts: ['autohaus-baumhoff.de'], idFirma: 53670, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Dippoldiswalde S-R': {
        hosts: [
            'autohaus-dippoldiswalde.de',
            'dippoldiswalde-dev.autohaus-digital.de',
            'dippoldiswalde-live.autohaus-digital.de',
            'dippoldiswalde-next.autohaus-digital.de',
            'dippoldiswalde-pre-release.autohaus-digital.de',
            'dippoldiswalde-test.autohaus-digital.de',
        ],
        idFirma: 54130,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Autohaus Elmshorn S-R': {
        hosts: [
            'autohaus-elmshorn.de',
            'elmshorn-dev.autohaus-digital.de',
            'elmshorn-live.autohaus-digital.de',
            'elmshorn-next.autohaus-digital.de',
            'elmshorn-pre-release.autohaus-digital.de',
            'elmshorn-test.autohaus-digital.de',
        ],
        idFirma: 30173,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Autohaus Erlenhoff': {
        hosts: [
            'erlenhoff-dev.autohaus-digital.de',
            'erlenhoff-live.autohaus-digital.de',
            'erlenhoff-next.autohaus-digital.de',
            'erlenhoff-pre-release.autohaus-digital.de',
            'erlenhoff-test.autohaus-digital.de',
            'erlenhoff.de',
        ],
        idFirma: 52590,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Autohaus Feicht': { hosts: ['feicht.de'], idFirma: 50860, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Franke': { hosts: ['autohaus-franke.com'], idFirma: 49252, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus G. Neumann': { hosts: ['autohaus-neumann.de'], idFirma: 48801, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Hannuschka': {
        hosts: [
            'hannuschka-dev.autohaus-digital.de',
            'hannuschka-live.autohaus-digital.de',
            'hannuschka-next.autohaus-digital.de',
            'hannuschka-pre-release.autohaus-digital.de',
            'hannuschka-test.autohaus-digital.de',
            'opel-hannuschka.de',
        ],
        idFirma: 54794,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Autohaus Hoch': { hosts: ['autohaus-hoch.de'], idFirma: 53420, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Hoppe': { hosts: ['autohaus-hoppe.com'], idFirma: 53910, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Hoppe - Test Domain': { hosts: ['em26171.vautron05.eventomaxx.de'], idFirma: 53910, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Ihle': {
        hosts: [
            'ihle-nortorf-dev.autohaus-digital.de',
            'ihle-nortorf-live.autohaus-digital.de',
            'ihle-nortorf-next.autohaus-digital.de',
            'ihle-nortorf-pre-release.autohaus-digital.de',
            'ihle-nortorf-test.autohaus-digital.de',
        ],
        idFirma: 51410,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Autohaus Josef Geers': { hosts: ['autohaus-geers.de'], idFirma: 54565, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Kießling': { hosts: ['kiessling-zwickau.de'], idFirma: 36883, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Koch': { hosts: ['autohauskoch.com'], idFirma: 53920, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Küver': { hosts: ['kuever.com', 'autohaus-kuver.onepage.me'], idFirma: 54793, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Kuhn+Witte': { hosts: ['autohaus.kuhn-witte.de'], idFirma: 30156, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Lamminger': {
        hosts: [
            'lamminger-dev.autohaus-digital.de',
            'lamminger-live.autohaus-digital.de',
            'lamminger-next.autohaus-digital.de',
            'lamminger-pre-release.autohaus-digital.de',
            'lamminger-test.autohaus-digital.de',
            'autohaus-lamminger.de',
        ],
        idFirma: 53890,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Autohaus Lich': {
        hosts: [
            'lich-dev.autohaus-digital.de',
            'lich-live.autohaus-digital.de',
            'lich-next.autohaus-digital.de',
            'lich-pre-release.autohaus-digital.de',
            'lich-test.autohaus-digital.de',
            'autohaus-lich.de',
        ],
        idFirma: 54600,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Autohaus an der Lutherkirche': {
        hosts: [
            'ahl-dev.autohaus-digital.de',
            'ahl-live.autohaus-digital.de',
            'ahl-next.autohaus-digital.de',
            'ahl-pre-release.autohaus-digital.de',
            'ahl-test.autohaus-digital.de',
            'ahl-chemnitz.de',
        ],
        idFirma: 48123,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Autohaus Manz': { hosts: ['autohaus-manz.de'], idFirma: 11910, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Meinhold': { hosts: ['autohaus-meinhold.de'], idFirma: 11970, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Niggemeier': { hosts: ['niggemeier.de'], idFirma: 54778, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Nord': {
        hosts: [
            'guestrow-dev.autohaus-digital.de',
            'guestrow-live.autohaus-digital.de',
            'guestrow-next.autohaus-digital.de',
            'guestrow-pre-release.autohaus-digital.de',
            'guestrow-test.autohaus-digital.de',
            'auto-guestrow.de',
        ],
        idFirma: 30178,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Autohaus Perski': { hosts: ['autohaus-perski.de'], idFirma: 10190, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Pirna': { hosts: ['autohauspirna.de'], idFirma: 10970, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Rabus': { hosts: ['autohaus-rabus.de', 'autohaus-rabus.papillo.fun'], idFirma: 54789, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Range': { hosts: ['autohaus-range.de'], idFirma: 54360, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Rudolph': { hosts: ['seat-rudolph.com', 'vw-rudolph.com'], idFirma: 30150, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Schenkel': {
        hosts: [
            'schenkel-dev.autohaus-digital.de',
            'schenkel-live.autohaus-digital.de',
            'schenkel-next.autohaus-digital.de',
            'schenkel-pre-release.autohaus-digital.de',
            'schenkel-test.autohaus-digital.de',
            'autohaus-schenkel.de',
        ],
        idFirma: 54615,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Autohaus Seifert': { hosts: ['vw-seifert.de'], idFirma: 30150, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Schulz & Straube S-R': {
        hosts: [
            'schulz-straube-dev.autohaus-digital.de',
            'schulz-straube-live.autohaus-digital.de',
            'schulz-straube-next.autohaus-digital.de',
            'schulz-straube-pre-release.autohaus-digital.de',
            'schulz-straube-test.autohaus-digital.de',
            'schulz-straube.autohaus-digital.de',
        ],
        idFirma: 48921,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Autohaus Schulz & Straube': { hosts: ['schulz-straube.de'], idFirma: 48921, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Spranger': { hosts: ['autohaus-spranger.de'], idFirma: 10210, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Steinhoff': {
        hosts: ['autohaus-steinhoff.de', 'steinhoff-live.autohaus-digital.de', 'steinhoff-next.autohaus-digital.de', 'steinhoff-dev.autohaus-digital.de'],
        idFirma: 54782,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Autohaus Völkel': { hosts: ['autohaus-voelkel.de', 'hoppmann-schneider.de'], idFirma: 54785, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Vollmer': { hosts: ['autohaus-vollmer.de'], idFirma: 11440, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Weber': { hosts: ['autos-weber.de', 'autos-weber.com'], idFirma: 49612, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Weingärtner': {
        hosts: [
            'weingaertner-dev.autohaus-digital.de',
            'weingaertner-live.autohaus-digital.de',
            'weingaertner-next.autohaus-digital.de',
            'weingaertner-pre-release.autohaus-digital.de',
            'weingaertner-test.autohaus-digital.de',
            'autohaus-weingaertner.de',
        ],
        idFirma: 10370,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Autohaus Winter': { hosts: ['ah-winter.de'], idFirma: 53810, isDev: false, hideInListing: false, useOldVersion: true },
    'Autohaus Wittenberg': { hosts: ['ah-wittenberg.de'], idFirma: 11980, isDev: false, hideInListing: false, useOldVersion: true },
    'Automobile Werner': { hosts: ['automobile-werner.de'], idFirma: 12040, isDev: false, hideInListing: false, useOldVersion: true },
    'autonext': {
        hosts: [
            'autonext-dev.autohaus-digital.de',
            'autonext-live.autohaus-digital.de',
            'autonext-next.autohaus-digital.de',
            'autonext-pre-release.autohaus-digital.de',
            'autonext-test.autohaus-digital.de',
            'auto-next.de',
        ],
        idFirma: 54805,
        isDev: false,
        hideInListing: false,
    },
    'Autopark Dippel': { hosts: ['autopark-dippel.de'], idFirma: 53040, isDev: false, hideInListing: false, useOldVersion: true },
    'Autowelt Schuler': { hosts: ['autowelt-schuler.de'], idFirma: 30046, isDev: false, hideInListing: false, useOldVersion: true },
    'Autozentrale Sturm': { hosts: ['autozentrale-sturm.de'], idFirma: 54040, isDev: false, hideInListing: false, useOldVersion: true },
    'Autozentrale Sturm SR': {
        hosts: [
            'autozentrale-sturm-dev.autohaus-digital.de',
            'autozentrale-sturm-live.autohaus-digital.de',
            'autozentrale-sturm-next.autohaus-digital.de',
            'autozentrale-sturm-pre-release.autohaus-digital.de',
            'autozentrale-sturm-test.autohaus-digital.de',
        ],
        idFirma: 54040,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Autozentrum Frankenthal': { hosts: ['autozentrum-frankenthal.de'], idFirma: 54599, isDev: false, hideInListing: false, useOldVersion: true },
    'Auto Brass': { hosts: ['auto-brass.com'], idFirma: 54440, isDev: false, hideInListing: false, useOldVersion: true },
    'Auto Hofmann': { hosts: ['auto-hofmann.de'], idFirma: 30169, isDev: false, hideInListing: false, useOldVersion: true },
    'Auto Meyer': {
        hosts: [
            'automeyer-ochsenfurt.de',
            'automeyer-dev.autohaus-digital.de',
            'automeyer-live.autohaus-digital.de',
            'automeyer-next.autohaus-digital.de',
            'automeyer-pre-release.autohaus-digital.de',
            'automeyer-test.autohaus-digital.de',
        ],
        idFirma: 53770,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Auto Müller': { hosts: ['auto-mueller-online.de'], idFirma: 54100, isDev: false, hideInListing: false, useOldVersion: true },
    'Auto Zeilinger': {
        hosts: [
            'zeilinger-dev.autohaus-digital.de',
            'zeilinger-live.autohaus-digital.de',
            'zeilinger-next.autohaus-digital.de',
            'zeilinger-pre-release.autohaus-digital.de',
            'zeilinger-test.autohaus-digital.de',
            'auto-zeilinger.de',
        ],
        idFirma: 54625,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'AV Beier': { hosts: ['avbeier.de'], idFirma: 53850, isDev: false, hideInListing: false, useOldVersion: true },
    'AVEMO Fleet': { hosts: ['avemo-fleet.de'], idFirma: 30179, isDev: false, hideInListing: false, useOldVersion: true },
    'AVEMO Gruppe': { hosts: ['avemo-group.de'], idFirma: 30179, isDev: false, hideInListing: false, useOldVersion: true },
    'AZF Gruppe': { hosts: ['azf-gruppe.de'], idFirma: 54781, isDev: false, hideInListing: false, useOldVersion: true },
    'BaderMainzl': { hosts: ['badermainzl.de', 'innsiders-projekte.de'], idFirma: 54610, isDev: false, hideInListing: false, useOldVersion: true },
    'Best': { hosts: ['my-mobility.group'], idFirma: 30180, isDev: false, hideInListing: false, useOldVersion: true },
    'Best S-R': {
        hosts: [
            'best-familie-dev.autohaus-digital.de',
            'best-familie-live.autohaus-digital.de',
            'best-familie-next.autohaus-digital.de',
            'best-familie-pre-release.autohaus-digital.de',
            'best-familie-test.autohaus-digital.de',
            'autohaus-best.de',
        ],
        idFirma: 30180,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Block am Ring': { hosts: ['blockamring.net'], idFirma: 30167, isDev: false, hideInListing: false, useOldVersion: true },
    'Boxhammer': { hosts: ['boxhammer.de'], idFirma: 51460, isDev: false, hideInListing: false, useOldVersion: true },
    'Campingwelt Schuler': { hosts: ['campingwelt-schuler.de'], idFirma: 30046, isDev: false, hideInListing: false, useOldVersion: true },
    'Caravan Center Nord': {
        hosts: [
            'ccn-dev.autohaus-digital.de',
            'ccn-live.autohaus-digital.de',
            'ccn-next.autohaus-digital.de',
            'ccn-pre-release.autohaus-digital.de',
            'ccn-test.autohaus-digital.de',
            'caravan-center-nord.de',
        ],
        idFirma: 54787,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Dabag': { hosts: ['dabag.de'], idFirma: 30174, isDev: false, hideInListing: false, useOldVersion: true },
    'Dein Autozentrum Woldegk': {
        hosts: [
            'woldegk-dev.autohaus-digital.de',
            'woldegk-live.autohaus-digital.de',
            'woldegk-next.autohaus-digital.de',
            'woldegk-pre-release.autohaus-digital.de',
            'woldegk-test.autohaus-digital.de',
            'dein-gebrauchtwagen-zentrum.de',
        ],
        idFirma: 30175,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Die Autohaus Gruppe S-R': {
        hosts: [
            'die-autohaus-gruppe-dev.autohaus-digital.de',
            'die-autohaus-gruppe-live.autohaus-digital.de',
            'die-autohaus-gruppe-next.autohaus-digital.de',
            'die-autohaus-gruppe-pre-release.autohaus-digital.de',
            'die-autohaus-gruppe-test.autohaus-digital.de',
            'die-autohaus-gruppe.de',
            'wernigerode-dev.autohaus-digital.de',
            'wernigerode-live.autohaus-digital.de',
            'wernigerode-next.autohaus-digital.de',
            'wernigerode-pre-release.autohaus-digital.de',
            'wernigerode-test.autohaus-digital.de',
            'wernigerode.die-autohaus-gruppe.de',
            'autohaus-am-regenstein-dev.autohaus-digital.de',
            'autohaus-am-regenstein-live.autohaus-digital.de',
            'autohaus-am-regenstein-next.autohaus-digital.de',
            'autohaus-am-regenstein-pre-release.autohaus-digital.de',
            'autohaus-am-regenstein-test.autohaus-digital.de',
            'regenstein.die-autohaus-gruppe.de',
            'halbac-dev.autohaus-digital.de',
            'halbac-live.autohaus-digital.de',
            'halbac-next.autohaus-digital.de',
            'halbac-pre-release.autohaus-digital.de',
            'halbac-test.autohaus-digital.de',
            'halbac.die-autohaus-gruppe.de',
            'quedac-dev.autohaus-digital.de',
            'quedac-live.autohaus-digital.de',
            'quedac-next.autohaus-digital.de',
            'quedac-pre-release.autohaus-digital.de',
            'quedac-test.autohaus-digital.de',
            'quedac.die-autohaus-gruppe.de',
            'Osterwieck-dev.autohaus-digital.de',
            'Osterwieck-live.autohaus-digital.de',
            'Osterwieck-next.autohaus-digital.de',
            'Osterwieck-pre-release.autohaus-digital.de',
            'Osterwieck-test.autohaus-digital.de',
            'osterwieck.die-autohaus-gruppe.de',
            'bergmann-dev.autohaus-digital.de',
            'bergmann-live.autohaus-digital.de',
            'bergmann-next.autohaus-digital.de',
            'bergmann-pre-release.autohaus-digital.de',
            'bergmann-test.autohaus-digital.de',
            'bergmann.die-autohaus-gruppe.de',
            'lcw-dev.autohaus-digital.de',
            'lcw-live.autohaus-digital.de',
            'lcw-next.autohaus-digital.de',
            'lcw-pre-release.autohaus-digital.de',
            'lcw-test.autohaus-digital.de',
            'lcw-wernigerode.die-autohaus-gruppe.de',
            'nora-osterwieck-dev.autohaus-digital.de',
            'nora-osterwieck-live.autohaus-digital.de',
            'nora-osterwieck-next.autohaus-digital.de',
            'nora-osterwieck-pre-release.autohaus-digital.de',
            'nora-osterwieck-test.autohaus-digital.de',
            'nora-zentrum-osterwieck.die-autohaus-gruppe.de',
        ],
        idFirma: 30008,
        isDev: false,
        hideInListing: false,
    },
    'Eichsfelder Autohaus': {
        hosts: [
            'eichsfelder-dev.autohaus-digital.de',
            'eichsfelder-live.autohaus-digital.de',
            'eichsfelder-next.autohaus-digital.de',
            'eichsfelder-pre-release.autohaus-digital.de',
            'eichsfelder-test.autohaus-digital.de',
            'eichsfelder-autohaus.de',
        ],
        idFirma: 54170,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Elbtor': { hosts: ['elbtor.de'], idFirma: 54150, isDev: false, hideInListing: false, useOldVersion: true },
    'Feddersen': { hosts: ['feddersen-automobile.de'], idFirma: 21700, isDev: false, hideInListing: false, useOldVersion: true },
    'Fink': {
        hosts: [
            'fink-dev.autohaus-digital.de',
            'fink-live.autohaus-digital.de',
            'fink-next.autohaus-digital.de',
            'fink-pre-release.autohaus-digital.de',
            'fink-test.autohaus-digital.de',
            'audi-fink.de',
        ],
        idFirma: 54623,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'FSN Autohaus': { hosts: ['fsn-autohaus.de', 'fsn-autozentrum.de'], idFirma: 30168, isDev: false, hideInListing: false, useOldVersion: true },
    'Fugel Gruppe': { hosts: ['fugel-gruppe.de'], idFirma: 30161, isDev: false, hideInListing: false, useOldVersion: true },
    'Gebr Conrad': { hosts: ['gebr-conrad.de'], idFirma: 48731, isDev: false, hideInListing: false, useOldVersion: true },
    'Glöckner Automobile': { hosts: ['gloeckner-automobile.de'], idFirma: 30170, isDev: false, hideInListing: false, useOldVersion: true },
    'Grampp': {
        hosts: [
            'grampp-dev.autohaus-digital.de',
            'grampp-live.autohaus-digital.de',
            'grampp-next.autohaus-digital.de',
            'grampp-pre-release.autohaus-digital.de',
            'grampp-test.autohaus-digital.de',
            'grampp.net',
        ],
        idFirma: 51530,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Gröditzer Autohaus': { hosts: ['groeditzer-autohaus.de'], idFirma: 13540, isDev: false, hideInListing: false, useOldVersion: true },
    'Hager und Penzel': {
        hosts: [
            'hager-penzel-dev.autohaus-digital.de',
            'hager-penzel-live.autohaus-digital.de',
            'hager-penzel-next.autohaus-digital.de',
            'hager-penzel-pre-release.autohaus-digital.de',
            'hager-penzel-test.autohaus-digital.de',
            'hager-und-penzel.de',
        ],
        idFirma: 54795,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Henke Automobile - SEAT Wedel': { hosts: ['seat-wedel.de'], idFirma: 30156, isDev: false, hideInListing: false, useOldVersion: true },
    'Hoppmann': { hosts: ['hoppmann-autowelt.de', 'fahrzeugmarkt.hoppmann-autowelt.de'], idFirma: 54612, isDev: false, hideInListing: false, useOldVersion: true },
    'Kaesmann': { hosts: ['kaesmann.de'], idFirma: 54622, isDev: false, hideInListing: false, useOldVersion: true },
    'KFZ Rothmund': {
        hosts: [
            'rothmund-dev.autohaus-digital.de',
            'rothmund-live.autohaus-digital.de',
            'rothmund-next.autohaus-digital.de',
            'rothmund-pre-release.autohaus-digital.de',
            'rothmund-test.autohaus-digital.de',
            'kfz-rothmund.de',
        ],
        idFirma: 54804,
        isDev: false,
        hideInListing: false,
    },
    'Kuenzig Bleuel': {
        hosts: [
            'k-b-dev.autohaus-digital.de',
            'k-b-live.autohaus-digital.de',
            'k-b-next.autohaus-digital.de',
            'k-b-pre-release.autohaus-digital.de',
            'k-b-test.autohaus-digital.de',
            'kuenzig-bleuel.de',
        ],
        idFirma: 54624,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Kuenzig Bleuel Hyundai': {
        hosts: [
            'k-b-h-dev.autohaus-digital.de',
            'k-b-h-live.autohaus-digital.de',
            'k-b-h-next.autohaus-digital.de',
            'k-b-h-pre-release.autohaus-digital.de',
            'k-b-h-test.autohaus-digital.de',
            'hyundai.kuenzig-bleuel.de',
        ],
        idFirma: 54624,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Leo Belting': { hosts: ['leo-belting.de'], idFirma: 46950, isDev: false, hideInListing: false, useOldVersion: true },
    'Liliensiek': {
        hosts: [
            'liliensiek.de',
            'liliensiek-dev.autohaus-digital.de',
            'liliensiek-live.autohaus-digital.de',
            'liliensiek-next.autohaus-digital.de',
            'liliensiek-pre-release.autohaus-digital.de',
            'liliensiek-test.autohaus-digital.de',
        ],
        idFirma: 13890,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Marnet': { hosts: ['marnet.de'], idFirma: 54619, isDev: false, hideInListing: false, useOldVersion: true },
    'Mieten Kaufen Reisen': { hosts: ['mietenkaufenreisen.de'], idFirma: 10200, isDev: false, hideInListing: false, useOldVersion: true },
    'Next Camper': { hosts: ['next-camper.de'], idFirma: 10200, isDev: false, hideInListing: false, useOldVersion: true },
    'Nullaufhundert': {
        hosts: ['nullaufhundert.de', 'beta.vw-rudolph.com'],
        idFirma: 30150,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Otto Grimm': { hosts: ['otto-grimm.de'], idFirma: 30009, isDev: false, hideInListing: false, useOldVersion: true },
    'OutletCars': {
        hosts: [
            'outletcars-dev.autohaus-digital.de',
            'outletcars-live.autohaus-digital.de',
            'outletcars-next.autohaus-digital.de',
            'outletcars-pre-release.autohaus-digital.de',
            'outletcars-test.autohaus-digital.de',
            'outletcars.de',
        ],
        idFirma: 54630,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Reim Automobile': {
        hosts: [
            'reim-automobile.de',
            'reim-dev.autohaus-digital.de',
            'reim-live.autohaus-digital.de',
            'reim-next.autohaus-digital.de',
            'reim-pre-release.autohaus-digital.de',
            'reim-test.autohaus-digital.de',
        ],
        idFirma: 54090,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Rolf Moser': {
        hosts: [
            'moser-autohaus.de',
            'moser-dev.autohaus-digital.de',
            'moser-live.autohaus-digital.de',
            'moser-next.autohaus-digital.de',
            'moser-pre-release.autohaus-digital.de',
            'moser-test.autohaus-digital.de',
        ],
        idFirma: 54802,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Salzmann Automobile': { hosts: ['salzmann-automobile.de'], idFirma: 51440, isDev: false, hideInListing: false, useOldVersion: true },
    'Schäfer Automobile': { hosts: ['schaeferautomobile.de'], idFirma: 54330, isDev: false, hideInListing: false, useOldVersion: true },
    'Schmeink-Gruppe-DEV': { hosts: ['asw.hinsken-advertising.de'], idFirma: 54632, isDev: false, hideInListing: false, useOldVersion: true },
    'Schmeink-Gruppe': { hosts: ['schmeink-gruppe.de'], idFirma: 54632, isDev: false, hideInListing: false, useOldVersion: true },
    'Spindler': {
        hosts: [
            'autohaus-rennsteig.de',
            'rennsteig-dev.autohaus-digital.de',
            'rennsteig-live.autohaus-digital.de',
            'rennsteig-next.autohaus-digital.de',
            'rennsteig-pre-release.autohaus-digital.de',
            'rennsteig-test.autohaus-digital.de',
            'spindler-gruppe.de',
            'spindler-dev.autohaus-digital.de',
            'spindler-live.autohaus-digital.de',
            'spindler-next.autohaus-digital.de',
            'spindler-pre-release.autohaus-digital.de',
            'spindler-test.autohaus-digital.de',
            'spindler-gruppe-dev.autohaus-digital.de',
            'spindler-gruppe.autohaus-digital.de',
            'spindler-gruppe-next.autohaus-digital.de',
            'spindler-gruppe-pre-release.autohaus-digital.de',
            'spindler-gruppe-test.autohaus-digital.de',
            'spindler-classics.de',
            'spindler-classix-dev.autohaus-digital.de',
            'spindler-classix-live.autohaus-digital.de',
            'spindler-classix-next.autohaus-digital.de',
            'spindler-classix-pre-release.autohaus-digital.de',
            'spindler-classix-test.autohaus-digital.de',
        ],
        idFirma: 54390,
        isDev: false,
        hideInListing: false,
    },
    'Sportivo': {
        hosts: [
            'sportivoleipzig.de',
        ],
        idFirma: 30124,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Sportivo SR': {
        hosts: [
            'sportivo-dev.autohaus-digital.de',
            'sportivo-live.autohaus-digital.de',
            'sportivo-next.autohaus-digital.de',
            'sportivo-pre-release.autohaus-digital.de',
            'sportivo-test.autohaus-digital.de',
        ],
        idFirma: 30124,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Thomas Exclusive Cars': { hosts: ['thomas.vollblut-digital.de', 'thomas-exclusive-cars.de'], idFirma: 30181, isDev: false, hideInListing: false, useOldVersion: true },
    'Thomas Exclusive Cars - Aston Martin': { hosts: ['aston-martin.devbite.me', 'astonmartin-dresden.de'], idFirma: 53410, isDev: false, hideInListing: false, useOldVersion: true },
    'Thomas Heavy Metal Bikes': { hosts: ['harley-dresden.com', 'harley-leipzig.com', 'harley-chemnitz.de'], idFirma: 30177, isDev: false, hideInListing: false, useOldVersion: true },
    'Tiemeyer': {
        hosts: [
            'tiemeyer.de',
            'tiemeyer-dev.autohaus-digital.de',
            'tiemeyer-live.autohaus-digital.de',
            'tiemeyer-next.autohaus-digital.de',
            'tiemeyer-pre-release.autohaus-digital.de',
            'tiemeyer-test.autohaus-digital.de',
        ],
        idFirma: 54587,
        isDev: false,
        hideInListing: false,
        useOldVersion: true,
    },
    'Vogt Mobil': { hosts: ['vogt-mobil.de'], idFirma: 54783, isDev: false, hideInListing: false, useOldVersion: true },
    'VW Arnold': { hosts: ['vw-arnold.de'], idFirma: 53180, isDev: false, hideInListing: false, useOldVersion: true },
    'Walter Schneider GmbH & Co KG': { hosts: ['walter-schneider.de'], idFirma: 54613, isDev: false, hideInListing: false, useOldVersion: true },

    // FOR TESTS - DO NOT DELETE!
    'Test': { hosts: ['test'], idFirma: 9800, isDev: false, hideInListing: true, useOldVersion: true },
    'Test - No idFirma': {
        hosts: ['testnoidfirma'],
        idFirma: 9800,
        isDev: true,
        hideInListing: true,
        useOldVersion: true,
    },
    'Test - No contactIsLeadSystem': {
        hosts: ['testnocontactleadsystem'],
        idFirma: 9800,
        isDev: true,
        hideInListing: true,
        useOldVersion: true,
    },
    'Test - No linkDisclaimer': {
        hosts: ['testnolinkdisclaimer'],
        idFirma: 9800,
        isDev: true,
        hideInListing: true,
        useOldVersion: true,
    },
    'Test - Not enabled': {
        hosts: ['testnotenabled'],
        idFirma: 9800,
        isDev: true,
        hideInListing: true,
        useOldVersion: true,
    },
    'Test - Modules not enabled': {
        hosts: ['testfinanzierungnotenabled', 'testaktionnotenabled', 'testschnellsuchenotenabled'],
        idFirma: 9800,
        isDev: true,
        hideInListing: true,
        useOldVersion: true,
    },
};
